import hotkeys from 'hotkeys-js';
import {toggleMeilisearchSearchModal} from "functions/helper";

export function initShortcuts() {
    hotkeys('ctrl+k', function (event, handler) {
        event.preventDefault()
        toggleMeilisearchSearchModal()
    });
}
